// Hooks
import { useEffect, useState } from 'react';

// Translation Library
import { useTranslation } from 'react-i18next';

// Material UI Library
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import FormHelperText from '@mui/material/FormHelperText';




const baseURL = process.env.REACT_APP_API_BASE_URL;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  }, 
};

export default function MedicalInterests({formData, handleChange, errorsData}) {
  const { t, i18n } = useTranslation();
  let [medicalInterests, setMedicalInterests] = useState([])
  
  useEffect(()=>{
    const fetchMedicalInterests  = async ()=>{
      try {
        const res = await fetch(`${baseURL}/medical-interests`)
        if (!res.ok) {
        throw new Error(`API Error: ${res.status}`);
        }
        else {
          const data = await res.json();
          setMedicalInterests(data.data)
        }
      }
      catch(error) {
        console.log(error)
      }
    }
    fetchMedicalInterests()
  },[])

  return (
    <>
      <FormControl className="w-full">
        <InputLabel error={errorsData.interests}>{t("medical_interests")}</InputLabel>
        <Select
          error={errorsData.interests}
          name='interests'
          multiple
          value={formData.interests}
          onChange={handleChange}
          input={<OutlinedInput label="Medical Interests" />}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((elementSelected) => {
                const item = medicalInterests.find((element) => element.id === elementSelected);
                return <Chip key={elementSelected} label={i18n.language === "en" ? item.name_en : item.name_ar} />;
              })}
            </Box>
          )}
          MenuProps={MenuProps}
        >
          {medicalInterests.map((element) => (
            <MenuItem
              key={element.id}
              value={element.id}
            >
              {i18n.language === "en" ? element.name_en : element.name_ar}
            </MenuItem>
          ))}
        </Select>
        {errorsData.interests ? (
        <FormHelperText sx={{ color: 'error.main' }}>{t("please_select_at_least_one_area_of_interest")}</FormHelperText>
        ): ""}
      </FormControl>
    </>
  );
}
